import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import DashboardView from "./DashboardView";
import ContactMessages from "./ContactMessages";
import FeedbackMessages from "./FeedbackMessages";
import ProjectLikes from "./ProjectLikes";
import PortfolioAnalytics from "./PortfolioAnalytics";
import ProjectSharingAnalytics from "./ProjectSharingAnalytics";
import BlogSharingAnalytics from "./BlogSharingAnalytics";
import SettingsView from "./SettingsView";

// Topmate Bookings Management
import TopmateOverview from "./TopmateBookings/TopmateOverview";
import TopmateRecentBookings from "./TopmateBookings/TopmateRecentBookings";
import TopmatePurchases from "./TopmateBookings/TopmatePurchases";
import TopmateAnalytics from "./TopmateBookings/TopmateAnalytics";
import TopmateEmailLogs from "./TopmateBookings/TopmateEmailLogs";
import TopmateWebhookLogs from "./TopmateBookings/TopmateWebhookLogs";

// Events Management
import EventsOverview from "./Events/EventsOverview";
import AllEvents from "./Events/AllEvents";
import EventRegistrations from "./Events/EventRegistrations";
import EventSharingAnalytics from "./EventSharingAnalytics";

import "./Admin.css";

function Admin() {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<DashboardView />} />
        <Route path="contact-messages" element={<ContactMessages />} />
        <Route path="feedback-messages" element={<FeedbackMessages />} />
        <Route path="project-likes" element={<ProjectLikes />} />
        <Route path="portfolio-analytics" element={<PortfolioAnalytics />} />
        <Route path="project-sharing-analytics" element={<ProjectSharingAnalytics />} />
        <Route path="share-analytics" element={<ProjectSharingAnalytics />} />
        <Route path="blog-sharing-analytics" element={<BlogSharingAnalytics />} />
        <Route path="event-sharing-analytics" element={<EventSharingAnalytics />} />
        <Route path="settings" element={<SettingsView />} />

        {/* Events Management Routes */}
        <Route path="events" element={<EventsOverview />} />
        <Route path="events/overview" element={<EventsOverview />} />
        <Route path="events/all" element={<AllEvents />} />
        <Route path="events/registrations" element={<EventRegistrations />} />
        <Route path="events/sharing-analytics" element={<EventSharingAnalytics />} />

        {/* Topmate Bookings Management Routes */}
        <Route path="topmatebookings" element={<TopmateOverview />} />
        <Route path="topmatebookings/recent" element={<TopmateRecentBookings />} />
        <Route path="topmatebookings/recent-bookings" element={<TopmateRecentBookings />} />
        <Route path="topmatebookings/purchases" element={<TopmatePurchases />} />
        <Route path="topmatebookings/digital-purchases" element={<TopmatePurchases />} />
        <Route path="topmatebookings/analytics" element={<TopmateAnalytics />} />
        <Route path="topmatebookings/emaillogs" element={<TopmateEmailLogs />} />
        <Route path="topmatebookings/webhooklogs" element={<TopmateWebhookLogs />} />
      </Routes>
    </AdminLayout>
  );
}

export default Admin;